import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { destinations } from '../../../mocks/destinations';

export default function DestinationsSection() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section ref={ref} className="py-12 sm:py-16 lg:py-24 px-4 sm:px-6 lg:px-12 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            className="font-inter text-3xl sm:text-4xl lg:text-6xl font-extrabold text-night-blue mb-6"
          >
            <strong>STATIONS DESSERVIES</strong>
          </motion.h2>
        </div>

        <div className="overflow-x-auto pb-6 -mx-4 sm:-mx-6 px-4 sm:px-6">
          <div className="flex gap-4 sm:gap-5 min-w-max">
            {destinations.map((destination, index) => (
              <motion.article
                key={destination.id}
                initial={{ opacity: 0, x: 50 }}
                animate={inView ? { opacity: 1, x: 0 } : {}}
                transition={{ delay: 0.1 * index }}
                className="bg-white rounded-2xl shadow-lg overflow-hidden w-72 sm:w-80 flex-shrink-0 hover:shadow-xl transition-shadow cursor-pointer"
              >
                <div className="h-40 sm:h-48 overflow-hidden">
                  <img
                    src={destination.image}
                    alt={`Transfert privé vers ${destination.name} - Station de ski ${destination.type}`}
                    title={`Transport premium vers ${destination.name} depuis Genève et Lyon`}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 sm:p-6">
                  <div className="mb-3">
                    <p className="text-slate-500 font-inter text-xs sm:text-sm mb-1">{destination.type}</p>
                    <h3 className="font-inter text-night-blue text-lg sm:text-xl font-bold"><strong>{destination.name}</strong></h3>
                  </div>
                  
                  <div className="space-y-2 mb-3">
                    <div className="flex justify-between items-center">
                      <span className="text-slate-600 font-inter text-xs sm:text-sm">Mercedes Classe E Berline 3pax</span>
                      <span className="font-inter text-night-blue text-lg sm:text-xl font-bold"><strong>€{destination.price}</strong></span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-slate-600 font-inter text-xs sm:text-sm">Mercedes Classe V 7pax</span>
                      <span className="font-inter text-night-blue text-lg sm:text-xl font-bold"><strong>€{destination.priceVan}</strong></span>
                    </div>
                  </div>
                  
                  <p className="text-slate-600 font-inter text-xs sm:text-sm mt-3 pt-3 border-t border-slate-200">{destination.distance}</p>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}